import { useSelector } from '@hh.ru/front-static-app';

import { UserSubscription, HH_PRO_ACTIVE_STATUSES } from 'src/types/hhpro';

const useActiveSubscription = (): UserSubscription | undefined => {
    return useSelector((store) =>
        store.hhPro?.userSubscriptions.find((item) => HH_PRO_ACTIVE_STATUSES.includes(item.status))
    );
};

export default useActiveSubscription;
